'use client';

import { ActionButton, FormValue } from '../../../../components/form';
import layoutStyles from '../../../../styles/modules/layout.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { ContactConfirmFormProps } from '../../types';

function ContactConfirmForm({
  contactValue,
  onSubmit,
  onBack,
  isLoading,
  LinkButtonComponent,
}: ContactConfirmFormProps) {
  const handleSubmit = async () => {
    await onSubmit();
  };

  const handleBack = () => {
    onBack();
  };

  return (
    <form>
      <div className={layoutStyles.formWrapper}>
        <FormValue label='問い合わせ内容'>{contactValue.selectCategory.name}</FormValue>
        <FormValue label='名前'>{contactValue.name}</FormValue>
        <FormValue label='メールアドレス'>{contactValue.email}</FormValue>
        <FormValue label='問い合わせ内容'>
          <p className={utilsStyles.textPrewrap}>{contactValue.description}</p>
        </FormValue>
        <FormValue label='添付画像'>{contactValue.files.length}件</FormValue>
      </div>
      <div className={`${layoutStyles.centeredBtnWrapper} ${utilsStyles.mtMedium}`}>
        <ActionButton onClick={handleSubmit} disabled={isLoading}>
          問い合わせを送信する
        </ActionButton>
        {LinkButtonComponent ? (
          <LinkButtonComponent href='/contact' outlined={true}>
            戻る
          </LinkButtonComponent>
        ) : (
          <ActionButton onClick={handleBack} outlined={true}>
            戻る
          </ActionButton>
        )}
      </div>
    </form>
  );
}

export default ContactConfirmForm;
